async function commentsBlock(id) {
    let ghostUrl = BASE_URL + '/'
    let commentsLimit = 5

    // responses
    let aboutMe
    await fetch(ghostUrl + 'members/api/member').then(res => res.json()).then(data => aboutMe = data).catch(function (error) {
        console.log(error);
    });

    if (!aboutMe?.uuid) {
        await fetch(
            ghostUrl +
            `members/api/member/setpathauthredirect?postURLForAuthRedirect=${window.location.href}`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
    } else {
        await fetch(ghostUrl + 'members/api/member/getpathauthredirect')
            .then((response) => response.json())
            .then(async (data) => {
                if (data?.member_auth_redirect_path?.data) {
                    await fetch(
                        ghostUrl +
                        'members/api/member/setpathauthredirect?postURLForAuthRedirect=',
                        {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }
                    );
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    let commentsMeta = {
        limit: 5,
        next: null,
        page: 1,
        pages: 1,
        prev: null,
        total: 1,
    }
    await fetch(ghostUrl + 'members/api/comments/?filter=post_id%3A' + id + '%2Bstatus%3A[published,hidden,updated]&limit=' + commentsLimit).then(response => response.json()).then(data => {
        if (data.meta.pagination) {
            commentsMeta = data.meta.pagination
        }
    }).catch(function (error) {
        console.log(error);
    });

    let commentsData = []

    await fetch(ghostUrl + 'members/api/comments/?filter=post_id%3A' + id + '%2Bstatus%3A[published,hidden,updated]&limit=' + commentsLimit + '&page=' + commentsMeta.pages).then(response => response.json()).then(data => {
        commentsMeta = data.meta.pagination
        commentsData = data.comments.reverse()
    }).catch(function (error) {
        console.log(error);
    });

    let commentsCnt

    await fetch(ghostUrl + 'members/api/comments/counts/?ids=' + id).then(response => response.json()).then(data => {
        commentsCnt = data
    }).catch(function (error) {
        console.log(error);
    });

    // title and comments block
    const articleComments = document.querySelector('.article-comments')

    let commentsTitle = document.createElement('div')
    commentsTitle.classList.add('comments-title')
    commentsTitle.textContent = `Коментарі`

    let commentsCounter = document.createElement('div')
    commentsCounter.classList.add('comments-counter')
    commentsCounter.textContent = `(${commentsCnt[id]})`

    if (commentsMeta.total == 0) {
        commentsCounter.style.display = 'none'
    }

    let commentsTitleContainer = document.createElement('div')
    commentsTitleContainer.classList.add('comments-title-container')
    commentsTitleContainer.appendChild(commentsTitle)
    commentsTitleContainer.appendChild(commentsCounter)

    const previousCommentsButton = document.createElement('input')
    previousCommentsButton.classList.add('more-comments-button')
    previousCommentsButton.classList.add('previous-comments-button')
    previousCommentsButton.type = 'button'
    previousCommentsButton.value = `Показати ще ${commentsMeta.limit} коментарів`
    if (commentsMeta.total <= 5) {
        previousCommentsButton.style.display = 'none'
    }

    previousCommentsButton.addEventListener('click', async () => {
        await fetch(ghostUrl +  'members/api/comments/?filter=post_id%3A' + id + '%2Bstatus%3A[published,hidden,updated]&limit=' + commentsLimit +'&page=' + commentsMeta.prev).then(response => response.json()).then(data => {
            commentsData.push(...data.comments.reverse())
            commentsMeta = data.meta.pagination
        }).catch(function (error) {
            console.log(error);
        });
        commentsBlock.innerHTML = ''
        commentsRender(commentsData, commentsBlock, id, 0)
        if (commentsMeta.page === 1) {
            previousCommentsButton.style.display = 'none'
        } else {
            previousCommentsButton.style.display = 'block'
        }
    })

    const noCommentsText = document.createElement('p')
    noCommentsText.textContent = 'Твій коментар може стати першим!'
    const noCommentsTitle = document.createElement('div')
    noCommentsTitle.textContent = 'Коментарів ще немає'
    const noCommentsBlock = document.createElement('div')
    noCommentsBlock.classList.add('no-comments-block')
    noCommentsBlock.appendChild(noCommentsTitle)
    noCommentsBlock.appendChild(noCommentsText)

    const commentsBlock = document.createElement('div')
    commentsBlock.id = 'comments-block'

    if (commentsMeta.total == 0) {
        commentsBlock.appendChild(noCommentsBlock)
    }

    let userAvatar = document.createElement('img')
    userAvatar.classList.add("avatar")
    if (aboutMe && aboutMe.photo !== null) {
        userAvatar.src = aboutMe.photo
    } else {
        userAvatar.src = '/assets/built/images/header-member-avatar.svg'
    }
    //main reply form

    const replyButton = document.createElement('input')
    replyButton.classList.add('reply-button')
    replyButton.value = 'Відправити'
    replyButton.type = 'button'

    const replyCharactersCounter = document.createElement('div')
    replyCharactersCounter.classList.add('reply-characters-counter')

    const replyButtonsContainer = document.createElement('div')
    replyButtonsContainer.classList.add('reply-buttons-container')
    replyButtonsContainer.appendChild(replyButton)

    const replyInputField = document.createElement('textarea')
    replyInputField.classList.add('reply-input-field')
    replyInputField.required = true
    replyInputField.placeholder = 'Приєднатися до дискусії'
    replyInputField.maxLength = 4096
    replyCharactersCounter.textContent = `${replyInputField.value.length}/${replyInputField.maxLength} символів`


    const replyPanel = document.createElement('div')
    replyPanel.classList.add('reply-panel')
    replyPanel.appendChild(replyInputField)
    replyPanel.appendChild(replyCharactersCounter)

    const replyFieldForm = document.createElement('form')
    replyFieldForm.classList.add('reply-field-form')
    replyFieldForm.appendChild(replyPanel)
    replyFieldForm.appendChild(replyButtonsContainer)

    const userAvatarContainer = document.createElement('div')
    userAvatarContainer.classList.add('avatar-container')
    userAvatarContainer.classList.add('user-avatar-container')
    userAvatarContainer.appendChild(userAvatar)
    if (!aboutMe) {
        userAvatarContainer.style.display = 'none'
    }

    const replyFieldContainer = document.createElement('div')
    replyFieldContainer.classList.add('reply-field-container')
    replyFieldContainer.appendChild(userAvatarContainer)
    replyFieldContainer.appendChild(replyFieldForm)



    articleComments.appendChild(commentsTitleContainer)
    articleComments.appendChild(replyFieldContainer)
    articleComments.appendChild(commentsBlock)
    articleComments.appendChild(previousCommentsButton)

    const months = [
        'Січня',
        'Лютого',
        'Березня',
        'Квітня',
        'Травня',
        'Червня',
        'Липня',
        'Серпня',
        'Вересня',
        'Жовтня',
        'Листопада',
        'Грудня',
    ];
    const svgHeart = `<svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.73977 8.94929L6.77991 13.2071C7.96289 14.4539 9.94939 14.4539 11.1324 13.2071L15.1725 8.94929C16.8255 7.20718 16.8255 4.38267 15.1725 2.64056C13.5195 0.898457 10.8394 0.898458 9.18638 2.64056V2.64056C9.06122 2.77246 8.85106 2.77246 8.72591 2.64056V2.64056C7.07288 0.898458 4.3928 0.898458 2.73977 2.64056C1.08674 4.38267 1.08674 7.20718 2.73977 8.94929Z" stroke="#A9A9A9" stroke-width="1.5"/>
</svg>`
    const svgReply = `<svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.2707 15.5C18.0682 15.5 17.8777 15.3905 17.7772 15.2067L17.7615 15.1782C16.0792 12.14 12.8737 10.25 9.39674 10.25H8.33325V13.4375C8.33325 13.6633 8.1975 13.8673 7.98975 13.9558C7.7835 14.0428 7.5405 13.9993 7.37925 13.841L1.00425 7.65351C0.894752 7.54776 0.833252 7.40226 0.833252 7.25001C0.833252 7.09776 0.894752 6.95226 1.00425 6.84651L7.37925 0.659013C7.54125 0.501513 7.7835 0.456513 7.98975 0.544263C8.1975 0.632763 8.33325 0.836763 8.33325 1.06251V4.25151C14.1405 4.35201 18.8332 9.10701 18.8332 14.9375C18.8332 15.1947 18.6592 15.419 18.4102 15.4827C18.3637 15.4947 18.3172 15.5 18.2707 15.5ZM7.77075 9.12501H9.39674C12.5287 9.12501 15.4635 10.4968 17.4697 12.8083C16.4992 8.55651 12.687 5.37501 8.14575 5.37501H7.77075C7.46025 5.37501 7.20825 5.12301 7.20825 4.81251V2.39226L2.2035 7.25001L7.20825 12.1078V9.68751C7.20825 9.37701 7.46025 9.12501 7.77075 9.12501Z" fill="#A9A9A9"/>
</svg>`
    const svgDot = `<svg width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2.125" cy="1.375" r="1.375" fill="#A9A9A9"/>
        </svg>`
    const svgDeletedComment = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                           xmlns="http://www.w3.org/2000/svg" class="stroke-white opacity-80">
                <path d="M7 9.5C7 10.1566 7.12933 10.8068 7.3806 11.4134C7.63188 12.02 8.00017 12.5712 8.46447 13.0355C8.92876 13.4998 9.47995 13.8681 10.0866 14.1194C10.6932 14.3707 11.3434 14.5 12 14.5C12.6566 14.5 13.3068 14.3707 13.9134 14.1194C14.52 13.8681 15.0712 13.4998 15.5355 13.0355C15.9998 12.5712 16.3681 12.02 16.6194 11.4134C16.8707 10.8068 17 10.1566 17 9.5C17 8.84339 16.8707 8.19321 16.6194 7.58658C16.3681 6.97995 15.9998 6.42876 15.5355 5.96447C15.0712 5.50017 14.52 5.13188 13.9134 4.8806C13.3068 4.62933 12.6566 4.5 12 4.5C11.3434 4.5 10.6932 4.62933 10.0866 4.8806C9.47995 5.13188 8.92876 5.50017 8.46447 5.96447C8.00017 6.42876 7.63188 6.97995 7.3806 7.58658C7.12933 8.19321 7 8.84339 7 9.5V9.5Z"
                      stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path>
                <circle cx="12" cy="12" r="11.375" stroke="white" stroke-width="1.25"></circle>
                <path d="M19.5 20C19.092 19.6069 18.4941 19.2498 17.7403 18.9489C16.9864 18.6481 16.0915 18.4094 15.1066 18.2466C14.1217 18.0838 13.0661 18 12 18C10.9339 18 9.87831 18.0838 8.8934 18.2466C7.90848 18.4094 7.01357 18.6481 6.25975 18.9489C5.50593 19.2498 4.90796 19.6069 4.5 20"
                      stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>`
    const svgClosePopup = `<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><title/><g id="cross"><line class="cls-1" x1="7" x2="25" y1="7" y2="25"/><line class="cls-1" x1="7" x2="25" y1="25" y2="7"/></g></svg>`


    function autosize() {
        var el = this;
        if (el.scrollHeight < 720) {
            el.style.cssText = 'height:auto;';
            el.style.cssText = 'height:' + el.scrollHeight + 'px';
        } else {
            el.style.cssText = 'height:720px;';
            el.style.overflow = 'auto'
        }

    }

    const CheckSpaces2 = (str) => {
        return str.trim() !== '';
    }

    function commentsRender(data, parentElement, post_id, counter) {

        const container = document.createElement('div')
        container.classList.add('comments-container')

        if (data) {
            data.filter(
                d => d.status !== 'pending'
            ).forEach((d, i) => {
                if (noCommentsBlock) {
                    noCommentsBlock.remove()
                }
                let date = new Date(d.created_at)
                let deleteButton = document.createElement('div')
                deleteButton.classList.add(`delete-button`)
                deleteButton.classList.add("popup-button")
                deleteButton.role = 'button'
                deleteButton.textContent = 'Видалити'
                let openEditPopupButton = document.createElement('div')
                openEditPopupButton.classList.add("open-edit-popup-button")
                openEditPopupButton.classList.add("popup-button")
                openEditPopupButton.role = 'button'
                openEditPopupButton.textContent = 'Редагувати'

                let flexPopup = document.createElement('span')
                flexPopup.classList.add("flex-popup")
                flexPopup.appendChild(openEditPopupButton)
                flexPopup.appendChild(deleteButton)

                let dots = document.createElement('span')
                dots.classList.add("dots")
                dots.role = 'button'
                dots.insertAdjacentHTML('beforeend', svgDot);
                dots.insertAdjacentHTML('beforeend', svgDot);
                dots.insertAdjacentHTML('beforeend', svgDot);

                let moreButton = document.createElement('div')
                moreButton.classList.add("flex-button")
                moreButton.classList.add("more-button")
                moreButton.role = 'button'
                moreButton.appendChild(dots)


                if (aboutMe && aboutMe.uuid) {
                    if (d.member && aboutMe.uuid == d.member.uuid) {
                        moreButton.style.display = 'block'
                    } else {
                        moreButton.style.display = 'none'
                    }
                } else {
                    moreButton.style.display = 'none'
                }

                let subReplyPopupText = document.createElement('span')
                subReplyPopupText.classList.add("reply-buttons-text")
                subReplyPopupText.textContent = 'Відповісти'

                let subReplyPopupButton = document.createElement('button')
                subReplyPopupButton.classList.add("flex-button")
                subReplyPopupButton.classList.add("sub-reply-popup-button")
                subReplyPopupButton.insertAdjacentHTML('beforeend', svgReply);
                subReplyPopupButton.appendChild(subReplyPopupText)

                let likeCount = document.createElement('span')
                likeCount.classList.add("reply-buttons-text")
                likeCount.textContent = `${d.count.likes}`

                let likeButton = document.createElement('button')
                likeButton.classList.add("flex-button")
                likeButton.classList.add(`like-button`)
                likeButton.insertAdjacentHTML('beforeend', svgHeart);
                likeButton.appendChild(likeCount)

                if (d.liked) {
                    likeButton.classList.add('liked')
                }


                let likeButtonContainer = document.createElement('div')
                likeButtonContainer.classList.add(`like-button-container`)
                likeButtonContainer.appendChild(likeButton)

                let flexButtons = document.createElement('div')
                flexButtons.classList.add("flex-buttons")
                flexButtons.appendChild(likeButtonContainer)
                flexButtons.appendChild(subReplyPopupButton)
                flexButtons.appendChild(moreButton)
                flexButtons.appendChild(flexPopup)

                const editCharactersCounter = document.createElement('div')
                editCharactersCounter.classList.add('reply-characters-counter')

                let editConfirmButton = document.createElement('input')
                editConfirmButton.classList.add(`edit-confirm-button`)
                editConfirmButton.type = 'button'
                editConfirmButton.value = 'Відправити'

                let editCancel = document.createElement('input')
                editCancel.classList.add("edit-cancel")
                editCancel.value = 'Скасувати'
                editCancel.type = 'button'

                let editButtonsContainer = document.createElement('div')
                editButtonsContainer.classList.add("reply-buttons-container")
                editButtonsContainer.appendChild(editCancel)
                editButtonsContainer.appendChild(editConfirmButton)

                let editTextarea = document.createElement('textarea')
                editTextarea.classList.add(`edit-textarea`)
                editTextarea.placeholder = 'Внести зміни у коментар'
                editTextarea.maxLength = 4096
                editCharactersCounter.textContent = `${editTextarea.value.length}/${editTextarea.maxLength} символів`

                const replyPanel = document.createElement('div')
                replyPanel.classList.add('reply-panel')
                replyPanel.appendChild(editTextarea)
                replyPanel.appendChild(editCharactersCounter)

                let editFieldForm = document.createElement('form')
                editFieldForm.classList.add("reply-field-form")
                editFieldForm.classList.add("edit-field-form")
                editFieldForm.appendChild(replyPanel)
                editFieldForm.appendChild(editButtonsContainer)

                editTextarea.addEventListener('input', autosize);

                const subReplyCharactersCounter = document.createElement('div')
                subReplyCharactersCounter.classList.add('reply-characters-counter')

                let subReplyButton = document.createElement('input')
                subReplyButton.classList.add(`sub-reply-button`)
                subReplyButton.classList.add('sub-reply-button')
                subReplyButton.value = 'Відправити'
                subReplyButton.type = 'button'


                let subReplyCancel = document.createElement('input')
                subReplyCancel.classList.add("sub-reply-cancel")
                subReplyCancel.value = 'Скасувати'
                subReplyCancel.type = 'button'


                let replyButtonsContainer = document.createElement('div')
                replyButtonsContainer.classList.add("reply-buttons-container")
                replyButtonsContainer.appendChild(subReplyCancel)
                replyButtonsContainer.appendChild(subReplyButton)



                let subReplyTextarea = document.createElement('textarea')
                subReplyTextarea.classList.add(`sub-reply-textarea`)
                subReplyTextarea.placeholder = 'Відповісти на коментар'
                subReplyTextarea.required
                subReplyTextarea.maxLength = 4096
                subReplyCharactersCounter.textContent = `${subReplyTextarea.value.length}/${subReplyTextarea.maxLength} символів`
                subReplyTextarea.contenteditable = true
                if (!aboutMe) {
                    subReplyTextarea.textContent = 'Для відправки відповіді, будь ласка, зареєструйтеся або увійдіть на сайт'
                }


                const subReplyPanel = document.createElement('div')
                subReplyPanel.classList.add('reply-panel')
                subReplyPanel.appendChild(subReplyTextarea)
                subReplyPanel.appendChild(subReplyCharactersCounter)


                let subReplyFieldForm = document.createElement('form')
                subReplyFieldForm.classList.add("reply-field-form")
                subReplyFieldForm.classList.add("sub-reply-field-form")
                subReplyFieldForm.appendChild(subReplyPanel)
                subReplyFieldForm.appendChild(replyButtonsContainer)
                if (!aboutMe) {
                    subReplyButton.disabled = true
                    subReplyButton.style.background = '#008BB7'
                    subReplyButton.style.opacity = '0.5'
                    subReplyTextarea.disabled = true
                }


                let userInfo = document.createElement('div')
                userInfo.classList.add("user-info")

                if (d.member) {
                    let h4 = document.createElement('div')
                    h4.classList.add("h4")
                    if (d.member.last_name) {
                        h4.textContent = d.member.first_name + ' ' + d.member.last_name
                    } else {
                        h4.textContent = d.member.first_name
                    }

                    let userDescription = document.createElement('span')
                    userDescription.classList.add("user-description")
                    if (d.member.expertise) {
                        if (d.member.company) {
                            userDescription.textContent = `${d.member.expertise} | ${d.member.company}`
                        } else {
                            userDescription.textContent = d.member.expertise
                        }
                    } else {
                        if (d.member.company) {
                            userDescription.textContent = d.member.company
                        } else {
                            userDescription.textContent = ''
                        }
                    }


                    userInfo.appendChild(h4)
                    userInfo.appendChild(userDescription)
                } else {
                    let deletedUserBlock = document.createElement('div')
                    deletedUserBlock.classList.add("h4")
                    deletedUserBlock.textContent = 'Видалений користувач'
                    userInfo.appendChild(deletedUserBlock)
                }

                let commentDate = document.createElement('span')
                commentDate.classList.add("comment-date")
                commentDate.textContent = `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear() !== new Date().getFullYear() ? date.getFullYear() : ''} ${date.getHours()}:${date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()} `

                let userInfoContainer = document.createElement('div')
                userInfoContainer.classList.add("user-info-container")
                userInfoContainer.appendChild(userInfo)
                userInfoContainer.appendChild(commentDate)

                let comment = document.createElement('div')
                comment.classList.add("comment-text")
                if (d.status !== "deleted" && d.status !== "hidden") {
                    comment.innerHTML = d.html
                } else {
                    comment.classList.add("deleted-block")
                    comment.innerHTML = `<p>Видалений коментар</p>`
                    flexButtons.style.visibility = 'hidden'
                }




                let block = document.createElement('div')
                block.classList.add("block")
                block.appendChild(userInfoContainer)
                block.appendChild(comment)
                block.appendChild(subReplyFieldForm)
                block.appendChild(editFieldForm)
                block.appendChild(flexButtons)

                let avatar = document.createElement('img')
                avatar.classList.add("avatar")


                if (d.member && d.member.photo !== null) {
                    avatar.src = d.member.photo
                } else {
                    avatar.src = '/assets/images/header-member-avatar.svg'
                }

                let avatarContainer = document.createElement('div')
                avatarContainer.classList.add('avatar-container')
                avatarContainer.appendChild(avatar)

                let flex = document.createElement('div')
                flex.classList.add("flex")

                flex.appendChild(avatarContainer)
                flex.appendChild(block)

                let replies = document.createElement('div')
                replies.classList.add("replies")

                if (counter > 3) {
                    replies.style.marginLeft = '0'
                }

                let commentsItem = document.createElement('div')
                commentsItem.classList.add("comment-item")
                commentsItem.appendChild(flex)
                commentsItem.appendChild(replies)

                let commentsItemContainer = document.createElement('div')
                commentsItemContainer.classList.add("comment-item-container")
                commentsItemContainer.appendChild(commentsItem)

                // functions

                // delete comment
                deleteButton.addEventListener('click', async () => {
                    await fetch(ghostUrl + 'members/api/comments/' + d.id, {
                        method: "DELETE",
                    })
                    flexPopup.classList.remove('__active');
                    openSubmitPopup('Коментар видалено!', `Найближчим часом він зникне зі сторінки.`)
                    data[i].status = 'hidden'
                    comment.classList.add("deleted-block")
                    comment.innerHTML = `<p>Видалений коментар</p>`
                    flexButtons.style.visibility = 'hidden'
                })

                // edit comment
                editTextarea.addEventListener('input', () => {
                    if (editTextarea.value.length >= 1 && CheckSpaces2(editTextarea.value)) {
                        editConfirmButton.style.opacity = '1'
                        editConfirmButton.disabled = false
                    } else {
                        editConfirmButton.style.opacity = '0.5'
                        editConfirmButton.disabled = true
                    }
                    if (editTextarea.value.length > 4000) {
                        editCharactersCounter.style.color = '#F34723'
                        editCharactersCounter.textContent = `${editTextarea.value.length}/${editTextarea.maxLength} символів!`
                    } else {
                        editCharactersCounter.textContent = `${editTextarea.value.length}/${editTextarea.maxLength} символів`
                        editCharactersCounter.style.color = 'black'
                    }
                })

                editConfirmButton.addEventListener('click', () => {
                    const dataObject = {
                        "comments": [
                            {
                                "id": d.id,
                                "html": `<p>${editTextarea.value}</p>`,
                            }
                        ]
                    }
                    fetch(ghostUrl + 'members/api/comments/' + d.id, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(dataObject)
                    })
                    editFieldForm.style.display = 'none'
                    flexButtons.style.display = 'flex'
                    comment.style.display = 'block'
                    openSubmitPopup('Дякуємо!', `Коментар змінено та буде опубліковано найближчим часом після проходження модерації.`)
                })
                // edit popup
                openEditPopupButton.addEventListener('click', () => {
                    flexButtons.style.display = 'none'
                    flexPopup.classList.add('__active');
                    editFieldForm.style.display = 'block'
                    editTextarea.value = comment.outerText
                    comment.style.display = 'none'
                    editCharactersCounter.textContent = `${editTextarea.value.length}/${editTextarea.maxLength} символів`
                    editTextarea.style.cssText = 'height:' + editTextarea.scrollHeight + 'px';
                })
                editCancel.addEventListener('click', () => {
                    editFieldForm.style.display = 'none'
                    flexButtons.style.display = 'flex'
                    comment.style.display = 'block'
                })

                // like comment
                likeButton.addEventListener('click', () => {
                        if (aboutMe) {
                            if (d.liked) {
                                data[i].liked = false
                                data[i].count.likes -= 1
                                likeButton.lastElementChild.innerHTML = data[i].count.likes
                                fetch(ghostUrl + 'members/api/comments/' + d.id + '/like/', {
                                    method: "DELETE",
                                })

                            } else {
                                data[i].liked = true
                                data[i].count.likes += 1
                                likeButton.lastElementChild.innerHTML = data[i].count.likes
                                fetch(ghostUrl + 'members/api/comments/' + d.id + '/like/', {
                                    method: "POST",
                                })
                            }
                            likeButton.classList.toggle('liked')
                        } else {
                            openSubmitPopup('', `Для здійснення дії, вам необхідно зареєструватися або авторизуватися на <a href="https://proit.org.ua">PROIT.ORG.UA</a>. Дякуємо за розуміння!`)
                        }
                })



                //sub reply comment

                subReplyTextarea.addEventListener('input', () => {
                    if (subReplyTextarea.value.length >= 1 && CheckSpaces2(subReplyTextarea.value)) {
                        subReplyButton.style.opacity = '1'
                    } else {
                        subReplyButton.style.opacity = '0.5'
                    }
                    if (subReplyTextarea.value.length > 4000) {
                        subReplyCharactersCounter.style.color = '#F34723'
                        subReplyCharactersCounter.textContent = `${subReplyTextarea.value.length}/${subReplyTextarea.maxLength} символів!`
                    } else {
                        subReplyCharactersCounter.textContent = `${subReplyTextarea.value.length}/${subReplyTextarea.maxLength} символів`
                        subReplyCharactersCounter.style.color = 'black'
                    }
                })




                subReplyButton.addEventListener('click', async () => {
                    const dataObject = {
                        "comments": [
                            {
                                "html": `<p>${subReplyTextarea.value}</p>`,
                                "parent_id": d.id,
                                "post_id": post_id,
                                "status": "published"
                            }
                        ]
                    }
                    if (subReplyTextarea.value.length >= 1 && CheckSpaces2(subReplyTextarea.value)) {
                        await fetch(ghostUrl + 'members/api/comments/', {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(dataObject)
                        }).then((res) => {
                            if (res.status !== 403) {
                                openSubmitPopup('Дякуємо!', `Ваш коментар буде опубліковано найближчим часом після проходження модерації`)
                            } else {
                                let error = new Error(res.statusText);
                                error.response = res;
                                throw error
                            }
                        }).catch((e) => {
                            if (e.response.status === 403) {
                                openSubmitPopup('Ваш коментар не може бути опублікований через використання заборонених слів.', 'Ми дбаємо про створення безпечного та поважного середовища для наших користувачів, тому, будь ласка, уникайте використання нецензурної лексики та образливих висловлювань. Дякуємо за розуміння.')
                            }
                        });
                        subReplyFieldForm.style.display = 'none'
                        flexButtons.style.display = 'flex'
                        subReplyTextarea.value = ''
                        subReplyCharactersCounter.textContent = `${0}/${subReplyTextarea.maxLength} символів`
                        subReplyCharactersCounter.style.color = 'black'
                    }
                })

                subReplyTextarea.addEventListener('input', autosize);

                // open flex popup
                // var style = window.getComputedStyle(flexPopup,"");
                // flexPopup.style.display = (style.display == 'none')?'block':'none';
                const hideMenu = (event) => {
                    flexPopup.classList.remove('__active');
                }
                const close = (event) => !flexPopup.contains(event.target) && hideMenu(event);


                moreButton.addEventListener('click', (event) => {
                    event.stopPropagation();
                    flexPopup.classList.toggle('__active');
                })
                window.addEventListener('click', close);

                // open close reply popup
                subReplyPopupButton.addEventListener('click', () => {
            if (aboutMe) {
                subReplyFieldForm.style.display = 'block'
                flexButtons.style.display = 'none'
            } else {
                openSubmitPopup('', `Для здійснення дії, вам необхідно зареєструватися або авторизуватися на <a href="https://proit.org.ua">PROIT.ORG.UA</a>. Дякуємо за розуміння!`)
            }
                })
                subReplyCancel.addEventListener('click', () => {
                    subReplyFieldForm.style.display = 'none'
                    flexButtons.style.display = 'flex'
                })

                // recursion
                if (d.replies) {
                    let cnt = counter + 1
                    commentsRender(d.replies, replies, id, cnt)
                }

                container.appendChild(commentsItemContainer)
            })
        }

        parentElement.append(container)
    }



    commentsRender(commentsData, commentsBlock, id, 0)


    // reply comment

    replyInputField.addEventListener('input', () => {
        if (replyInputField.value.length >= 1 && CheckSpaces2(replyInputField.value)) {
            replyButton.style.opacity = '1'
        } else {
            replyButton.style.opacity = '0.5'
        }
        if (replyInputField.value.length > 4000) {
            replyCharactersCounter.style.color = '#F34723'
            replyCharactersCounter.textContent = `${replyInputField.value.length}/${replyInputField.maxLength} символів!`
        } else {
            replyCharactersCounter.textContent = `${replyInputField.value.length}/${replyInputField.maxLength} символів`
            replyCharactersCounter.style.color = 'black'
        }
    })



    replyButton.addEventListener('click', () => {
        const dataObject = {
            "comments": [
                {
                    "html": `<p>${replyInputField.value}</p>`,
                    "post_id": id,
                    "status": "published"
                }
            ]
        }
        if (replyInputField.value.length >= 1 && CheckSpaces2(replyInputField.value)) {
            fetch(ghostUrl + 'members/api/comments/', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(dataObject)
            }).then((res) => {
                if (res.status !== 403) {
                    openSubmitPopup('Дякуємо!', `Ваш коментар буде опубліковано найближчим часом після проходження модерації`)
                    replyInputField.value = ''
                    replyCharactersCounter.textContent = `${0}/${replyInputField.maxLength} символів`
                    replyInputField.style.cssText = 'height:auto;';
                } else {
                    let error = new Error(res.statusText);
                    error.response = res;
                    throw error
                }
            }).catch((e) => {
                if (e.response.status === 403) {
                    openSubmitPopup('Ваш коментар не може бути опублікований через використання заборонених слів.', 'Ми дбаємо про створення безпечного та поважного середовища для наших користувачів, тому, будь ласка, уникайте використання нецензурної лексики та образливих висловлювань. Дякуємо за розуміння.')
                }
            });
        }
    })

    replyInputField.addEventListener('input', autosize);



    if (!aboutMe) {
        replyInputField.disabled = true
        replyInputField.placeholder = 'Щоб залишити коментар, Вам необхідно зареєструватися/авторизуватися в нашій системі. Дякуємо за розуміння!'
        replyButton.disabled = true
        replyButton.style.background = '#008BB7'
        replyButton.style.opacity = '0.5'
    }

    // submitPopup
    function openSubmitPopup(title, text) {
        submitPopupWrapper.style.display = 'block'
        // document.body.style.overflow = 'hidden'
        submitPopupTitle.textContent = title
        submitPopupText.innerHTML = text
        function close() {
            // document.body.style.overflow = 'auto'
            submitPopupWrapper.style.display = 'none'
        }
        setTimeout(close, 5000);
    }


    let submitPopupCloseButton = document.createElement('button');
    submitPopupCloseButton.classList.add('submit-popup-close-button')
    submitPopupCloseButton.role = 'button'
    submitPopupCloseButton.insertAdjacentHTML('beforeend', svgClosePopup)
    submitPopupCloseButton.addEventListener('click', () => {
        document.body.style.overflow = 'auto'
        submitPopupWrapper.style.display = 'none'
    })

    let submitPopupText = document.createElement('p')
    submitPopupText.textContent = `Найближчим часом він з'явиться на сторінці:)`

    let submitPopupTitle = document.createElement('h2')
    submitPopupTitle.textContent = 'Коментар надіслано!'

    let submitPopup = document.createElement('div')
    submitPopup.classList.add('submit-popup')
    submitPopup.appendChild(submitPopupTitle)
    submitPopup.appendChild(submitPopupText)
    submitPopup.appendChild(submitPopupCloseButton)

    let submitPopupContainer = document.createElement('div')
    submitPopupContainer.classList.add('submit-popup-container')
    submitPopupContainer.appendChild(submitPopup)

    let submitPopupWrapper = document.createElement('div')
    submitPopupWrapper.classList.add('submit-popup-wrapper')
    submitPopupWrapper.appendChild(submitPopupContainer)

    articleComments.appendChild(submitPopupWrapper)

    // close popup screen
    window.onclick = function (event) {
        if (event.target === submitPopupWrapper) {
            document.body.style.overflow = 'auto'
            submitPopupWrapper.style.display = 'none'
        }
    }
}